module.exports = __webpack_public_path__ + "static/img/sina_qrcode.a618d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sina_qrcode.jpg
// module id = zYG0
// module chunks = 1